window.addSpaces = function (nStr) {
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ' ' + '$2');
    }
    return x1 + x2;
}

window.updatePrices = function (dom, route, targets, selectTrial = false) {
    let code = $(dom).val()
    if (code.trim() === "") {
        code = 'not-inputed'
    }

    $.getJSON(route + "/" + code, function (data) {
        let selector = $(targets.selector)

        selector.find('option[value="trial"]').remove()

        if (data.hash === code) {
            if (data.price_profi_month == null) {
                data.price_profi_month = 375
            }
            if (data.price_profi_year == null) {
                data.price_profi_year = 3600
            }
            selector.find('option[value="profi-1"]').data('price', data.price_profi_month)
                .text('1 měsíc za ' + window.addSpaces(data.price_profi_month) + ' Kč bez DPH')
            selector.find('option[value="profi-12"]').data('price', data.price_profi_year)
                .text('12 měsíců za ' + window.addSpaces(data.price_profi_year) + ' Kč bez DPH')

            if (data.expiration_date != null) {
                selector.append('<option value="trial" data-price="0">Zdarma do ' + data.expiration_date + '</option>')
                if (selectTrial) {
                    selector.val("trial")
                }
            }
        } else {
            selector.find('option[value="profi-1"]').data('price', 375)
                .text('1 měsíc za 375 Kč bez DPH')
            selector.find('option[value="profi-12"]').data('price', 3600)
                .text('12 měsíců za 3 600 Kč bez DPH')
        }

        let price = selector.find('option:selected').data('price');

        if (typeof price !== 'undefined') {
            window.updatePriceText(targets.price_display, targets.price_vat, price);
            $(targets.final_price).val(price);
        }
    });
}

window.updatePriceText = function (target, targetVat, price) {
    let text = 'Objednat'
    $(targetVat).text('')
    if (parseInt(price) !== 0) {
        text = 'Objednat za ' + window.addSpaces(price) + ' Kč bez DPH'
        $(targetVat).text('Cena s DPH činí ' + window.addSpaces(Math.round(1.21 * parseFloat(price))) + ' Kč')
    }
    $(target).text(text)
}

window.openRealty = function (event, element) {
    //window.location = $(element).data('route');
    let url = $(element).data('route')
    let urlSplit = url.split('/')
    let delimiter = '?'
    if (urlSplit[urlSplit.length - 1].includes("?")) {
        delimiter = '&'
    }

    window.open(url  + delimiter + "close=1", "_blank")
}

window.openUrl = function (url) {
    window.open(url, "_blank");
}

window.initPano = function() {
    $('.street-view-toggle').on('click', function () {
        $('.street-view, .pano-view, .aerial-map').removeClass('visible');

        var target = $($(this).data('toggle'));

        if (!target.hasClass('visible')) {
            if (target.find('iframe').length == 0) {
                target.append($('<iframe>', {
                    width: 300,
                    height: 225,
                    src: 'https://www.google.com/maps/embed/v1/streetview\n' +
                        '?key=' + target.data('api') +
                        '&location=' + target.data('location') +
                        '&heading=' + (target.data('azimuth') ? target.data('azimuth') : 210) +
                        '&pitch=5' +
                        '&fov=90' +
                        '&source=outdoor',
                    frameborder: 0,
                    style: "border: 0"
                }));
            }
        }

        target.toggleClass('visible');
    });

    $('.pano-view-toggle').on('click', function () {
        console.log('init pano')
        $('.street-view, .pano-view, .aerial-map').removeClass('visible');

        var target = $($(this).data('toggle'));

        if (!target.hasClass('visible')) {
            const container = document.querySelector("#pano-view-" + target.data('id'));
            let gps = target.data('location').split(",")

            if (target.find('canvas').length === 0) {
                const pano = Panorama.panoramaFromPosition({
                    parent: container,
                    lon: gps[1],
                    lat: gps[0],
                    apiKey: target.data('api'),
                    showNavigation: true,
                });

                if (pano.error) {
                    target.textContent = `Code: ${pano.errorCode}\nMsg: ${pano.error}`;
                }
            }
        }

        target.toggleClass('visible');
    });

    $('.aerial-map-toggle').on('click', function () {
        $('.aerial-map').removeClass('visible');

        var target = $($(this).data('toggle'));

        if (!target.hasClass('visible')) {
            if (target.find('iframe').length == 0) {
                target.append($('<iframe>', {
                    width: 300,
                    height: 225,
                    src: "https://www.google.com/maps/embed/v1/place" +
                        "?key=" + target.data('api') +
                        "&q=" + target.data('location') +
                        "&zoom=18" +
                        "&maptype=satellite",
                    frameborder: 0,
                    style: "border: 0"
                }));
            }
        }

        target.toggleClass('visible');
    });

    $('.pano-view-toggle').on('click', function () {
        $('.pano-view').removeClass('visible');
        $($(this).data('toggle')).toggleClass('visible');
    });

    $('.street-view .close, .pano-view .close, .aerial-map .close').on('click', function () {
        $(this).parent().toggleClass('visible');
    });
}

window.countChecked = function (event, containerElement, counterElement, limit, error) {
    let container = $(containerElement)
    let counter = $(counterElement)
    let checkboxes = container.find('input[type="checkbox"]:checked')

    if (checkboxes.length > limit) {
        event.preventDefault()
        alert(error)
    } else {
        counter.html(checkboxes.length)
    }
}

window.initViewIframes = function (targetPanorama, targetStreetView, triggerStreetView) {
    let target = $(targetPanorama);

    if (target.length !== 0 && target.find('iframe').length == 0) {
        let gps = target.data('location').split(",");

        target.append($('<iframe>', {
            width: 300,
            height: 225,
            src: target.data('url') + '/' + gps[0] + '/' + gps[1],
            frameborder: 0,
            style: "border: 0"
        }))
    }

    $(triggerStreetView).on('click', function () {
        let target = $(targetStreetView);

        if (target.find('iframe').length == 0) {
            target.append($('<iframe>', {
                width: 300,
                height: 225,
                src: 'https://www.google.com/maps/embed/v1/streetview\n' +
                    '?key=' + target.data('api') +
                    '&location=' + target.data('location') +
                    '&heading=' + (target.data('azimuth') ? target.data('azimuth') : 210) +
                    '&pitch=5' +
                    '&fov=90' +
                    '&source=outdoor',
                frameborder: 0,
                style: "border: 0"
            }));
        }
    })
}

window.setActiveListElements = function (event, navElement) {
    var windowPos = $(window).scrollTop();
    $(navElement + ' li a[href^="#"]').each(function() {
        let currentLink = $(this);
        if ($(currentLink.attr("href")).length > 0) {
            let refElement = $(currentLink.attr("href"));
            if (refElement.position().top <= windowPos && (refElement.position().top + refElement.height() + $(navElement).height() ) > windowPos) {
                $(navElement + ' li a').removeClass("active");
                currentLink.addClass("active");
            }
            else{
                currentLink.removeClass("active");
            }
        }
    });
}

window.setFprModalStyle = function () {
    let filter = $(".filter-wrapper")
    let modal = $("#free-price-info")

    modal.css('top', filter.outerHeight())
        .css('height', "calc(100% - " + filter.outerHeight() + "px)")
}

window.checkFilesize = function (element) {
    if (element.files.length > 0) {
        let sizeSum = 0;
        for (let i = 0; i <= element.files.length - 1; i++) {
            const fsize = element.files.item(i).size;
            const file = Math.round((fsize / 1024));

            sizeSum += file;
        }

        if (sizeSum >= 25600) {
            element.value = null;
            alert("Nahrané soubory jsou příliš velké.\n\nProsím vyberte soubory o celkové velikosti do 25MB.");
        }
    }
}
